// Third party
import { PayloadAction } from '@reduxjs/toolkit';

// Components
import { IRootState } from './type';
import { initialState } from './slice';

const reducers = {
  setWorstWeaponPresentation: (state: IRootState, action: PayloadAction<IRootState['worst_weapon_presentation']>) => ({
    ...state,
    worst_weapon_presentation: [...state.worst_weapon_presentation, ...action.payload.filter(
      (rep) => !state.worst_weapon_presentation.some((r) => r.scenarioid === rep.scenarioid)
    )],
  }),
  setRankings: (
    state: IRootState,
    action: PayloadAction<IRootState['rankings']>
  ) => {
    if (!state.rankings.users) {
      state.rankings = action.payload;
      return;
    }

    const newUsers = action.payload.users.filter(
      (user) => !state.rankings.users.some((r) => r.user_id === user.user_id)
    );

    state.rankings.users.push(...newUsers);
  },
  setScores: (state: IRootState, action: PayloadAction<IRootState['scores']>) => ({
    ...state,
    scores: action.payload,
  }),
  setTotalTrainTime: (state: IRootState, action: PayloadAction<IRootState['total_train_time']>) => ({
    ...state,
    total_train_time: action.payload,
  }),
  resetDashboardData: () => initialState,
};

export { reducers };
